import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { http } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";

export default function AdminPartners() {
  const [items, setItems] = useState([]);
  const [draft, setDraft] = useState({ name: "", logo_url: "", link: "", display_order: 0, active: true });

  const load = () => http.get("/admin/partners").then((r) => setItems(r.data.partners || []));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await http.post("/admin/partners", { ...draft, display_order: Number(draft.display_order) || 0 });
      setDraft({ name: "", logo_url: "", link: "", display_order: 0, active: true });
      toast.success("Partner added");
      load();
    } catch { toast.error("Failed"); }
  };
  const update = async (p, patch) => {
    try { await http.put(`/admin/partners/${p.id}`, { ...p, ...patch }); load(); }
    catch { toast.error("Failed"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this partner?")) return;
    await http.delete(`/admin/partners/${id}`); load(); toast.success("Deleted");
  };

  return (
    <AdminLayout>
      <div className="bp-container py-8">
        <h1 className="font-serif text-4xl mb-2">Partners</h1>
        <p className="text-sm mb-8" style={{ color: "var(--bp-text-muted)" }}>Changes go live on the public site immediately.</p>

        <form onSubmit={create} className="p-5 bg-white border mb-8 grid grid-cols-1 md:grid-cols-6 gap-3 items-end" style={{ borderColor: "var(--bp-border)" }}>
          <div className="md:col-span-2"><label className="text-xs uppercase tracking-widest">Name</label><Input required value={draft.name} onChange={(e) => setDraft({ ...draft, name: e.target.value })} data-testid="partner-new-name" /></div>
          <div className="md:col-span-2"><label className="text-xs uppercase tracking-widest">Link</label><Input required type="url" value={draft.link} onChange={(e) => setDraft({ ...draft, link: e.target.value })} data-testid="partner-new-link" placeholder="https://…" /></div>
          <div><label className="text-xs uppercase tracking-widest">Logo URL</label><Input value={draft.logo_url} onChange={(e) => setDraft({ ...draft, logo_url: e.target.value })} data-testid="partner-new-logo" /></div>
          <div><label className="text-xs uppercase tracking-widest">Order</label><Input type="number" value={draft.display_order} onChange={(e) => setDraft({ ...draft, display_order: e.target.value })} data-testid="partner-new-order" /></div>
          <Button type="submit" className="rounded-none md:col-span-6" data-testid="partner-new-submit"><Plus size={14} className="mr-1" /> Add partner</Button>
        </form>

        <div className="bg-white border" style={{ borderColor: "var(--bp-border)" }}>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-left" style={{ borderColor: "var(--bp-border)" }}>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Order</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Name</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Link</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Logo</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Active</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-b" style={{ borderColor: "var(--bp-border)" }} data-testid={`partner-row-${p.name.toLowerCase().replace(/\s+/g, "-")}`}>
                  <td className="px-4 py-2">
                    <Input type="number" defaultValue={p.display_order} onBlur={(e) => update(p, { display_order: Number(e.target.value) || 0 })} className="w-20" />
                  </td>
                  <td className="px-4 py-2 font-serif">{p.name}</td>
                  <td className="px-4 py-2 font-mono text-xs"><a className="bp-link" href={p.link} target="_blank" rel="noopener noreferrer">{p.link}</a></td>
                  <td className="px-4 py-2 font-mono text-xs truncate max-w-[240px]">{p.logo_url || "—"}</td>
                  <td className="px-4 py-2">
                    <Switch checked={p.active} onCheckedChange={(v) => update(p, { active: v })} data-testid={`partner-active-${p.name.toLowerCase().replace(/\s+/g, "-")}`} />
                  </td>
                  <td className="px-4 py-2 text-right">
                    <button onClick={() => remove(p.id)} data-testid={`partner-delete-${p.name.toLowerCase().replace(/\s+/g, "-")}`}><Trash2 size={16} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
